import useEnrollmentPrice from "../../hooks/useEnrollmentPrice";
import { getDisplayedCoursePrice } from "../../utils/coursePricing";
import React from "react";
import Header from "../../layouts/header";
import Footer from "../../layouts/footer";
import { Field, ErrorMessage, Form, Formik } from "formik";
import { getUserData, enroll2ndCourse, updateBankruptcy } from "../../api/server";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import cross from "../../assets/images/SiteImg/cross.png";
import { login } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import StripeComponent from "../../common/stripeComponent";
import CreditReportAuthorizationModal from "./CreditReportAuthorizationModal";

const EnrollmentValidationSchema = Yup.object().shape({
  bankruptcytype: Yup.string().required("Bankruptcy Type is required"),
  bankruptcycasenum: Yup.string().required(
    "Bankruptcy Case Number is required"
  ),
});

const EnrollmentIn2ndCourse = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const [getloading, setGetLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModalSecond, setShowModalSecond] = useState(false);
  const [postLoadingSecond, setPostLoadingSecond] = useState(false);
  const secondEnrollmentLockRef = useRef(false);
  const [userData, setUserData] = useState();
  const secondPrice = useEnrollmentPrice(userData, "second", "Serious1", userId, undefined, location.state?.enrollmentQuote);
  const [courseSecondInfo, setCourseSecondInfo] = useState({
    bankruptcytype: "",
    bankruptcycasenum: "",
  });
  const [creditReportAuthorized, setCreditReportAuthorized] = useState(false);
  // console.log("userData>>>>>>", userData)
    const [freeCodeLoading, setFreeCodeLoading] = useState(false);
    const [freeCode, setFreeCode] = useState("");
    const [freeCodeError, setFreeCodeError] = useState("");
  
    const handleFreeCodeSubmit = async (modalId) => {
    if (!freeCode.trim()) {
      setFreeCodeError("Please enter a valid free course code.");
      return;
    }
  
    setFreeCodeError("");
    setFreeCodeLoading(true);
  
    try {
      const id =  userId ? userId : userData.id;
      const role = userId ? "admin" : "user";
  
      const values = {
        freeCourseCode: freeCode.trim(),
        creditReportAuthorized: !userId && creditReportAuthorized,
      };
  
      const res = await enroll2ndCourse(role, id, values);
      console.log("Enroll response:>>>>>>>>", res);
  
      if (res?.data?.success) {
        if (modalId && document.getElementById(modalId)) {
          document.getElementById(modalId).click();
        }
  
        toast.success("Successfully enrolled using free code!");
        if (!userId) {
          dispatch(login(res.data));
        }
        navigate(
          userId
            ? `/user-dashboard-page?id=${userId}`
            : `/security-law-questions?verification=true`
        );
      } else {
        toast.error(res?.data?.message || "An unexpected error occurred.");
      }
    } catch (err) {
      if (err.response?.data?.error) {
        toast.error(err.response.data.error);
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setFreeCodeLoading(false);
    }
  };
useEffect(() => {
  const resetFields = () => {
    setFreeCode("");
    setFreeCodeError("");
  };

  document.addEventListener("hide.bs.modal", resetFields);

  return () => {
    document.removeEventListener("hide.bs.modal", resetFields);
  };
}, []);

  const handleEnrollSecond = async (values) => {
    if (secondEnrollmentLockRef.current) return;

    secondEnrollmentLockRef.current = true;
    setPostLoadingSecond(true);
    let payment_mode = "Credit Card";

    if (
      userData?.billingoptions == "bill" ||
      userData?.billingoptions == "DE"
    ) {
      payment_mode = userData?.billingoptions;
    } else if (userData?.paid_second == "checked") {
      payment_mode = "Admin manually checked";
    }

    const newvalue = {
      ...values,
      payment_mode,
      creditReportAuthorized: !userId && creditReportAuthorized,
    };

    try {
      const res = await enroll2ndCourse(
        userId ? "admin" : "user",
        userId ? userId : userData.id,
        newvalue
      );

      if (!userId) {
        dispatch(login(res.data));
      }
      navigate(
        userId
          ? `/user-dashboard-page?id=${userId}`
          : `/security-law-questions?verification=true`
      );
    } catch (err) {
      if (err.response && err.response.data) {
        toast.error(err.response.data.error);
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      secondEnrollmentLockRef.current = false;
      setPostLoadingSecond(false);
    }
  };

  const handleSubmitSecond = async (values) => {
    handleEnrollSecond(values);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getUserData(userId);
        setUserData(response.data.data.user);
        setCreditReportAuthorized(
          response.data.data.user.credit_report === "checked"
        );
        setGetLoading(false);
      } catch (error) {
        setGetLoading(false);
        console.error("Error fetching data user:", error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <div>
      <Header />

      {showModalSecond && (
        <StripeComponent
          showModal={showModalSecond}
          setShowModal={setShowModalSecond}
          isLoading={postLoadingSecond}
          setIsLoading={setPostLoadingSecond}
          values={courseSecondInfo}
          pay={handleEnrollSecond}
          currentCourse="second"
          amount={secondPrice.data.amount}
        />
      )}
      {!userId && (
        <CreditReportAuthorizationModal
          modalId="EnrollmentCreditReportAuthorization"
          triggerId="triggerEnrollmentCreditReportAuthorization"
          nextTriggerId="triggerSerious1"
          checked={creditReportAuthorized}
          onChange={setCreditReportAuthorized}
          disabled={userData?.credit_report === "checked"}
          inputId="enrollment-credit-report-authorized"
        />
      )}
      {getloading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "200px" }}
        >
          <ThreeDots
            height="40"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
              display: "flex",
              justifyContent: "center",
            }}
            wrapperClassName="spinner"
            visible={true}
          />
        </div>
      ) : (
        <div className="theme_container">
          <div className="my-profile">
            <h1 id="firstcourse">
              Enroll in <span className="text_success">Second Course</span>
            </h1>
          </div>

          <div className="row mt-40">
            <div className="row mt-40"></div>
            <div className="btn_wrap text-center">
              <button
                type="button"
                className=" btn_brnd "
                // data-bs-toggle="modal"
                // data-bs-target="#Serious1"
                // data-bs-target="#SecondSerious"
                onClick={() => {
                  secondPrice.start();
                  if (userData?.bankruptcycasenum) {
                    document
                      .getElementById(
                        userId
                          ? "triggerSerious1"
                          : "triggerEnrollmentCreditReportAuthorization"
                      )
                      ?.click()

                  }
                  else {
                    document.getElementById("triggerSerious222")?.click()

                  }
                }}

                disabled={postLoadingSecond}
              >
                {postLoadingSecond ? (
                  <ThreeDots
                    height="20"
                    width="150"
                    radius="9"
                    color="#4fa94d"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{
                      display: "block",
                    }}
                    wrapperClassName="spinner"
                    visible={true}
                  />
                ) : (
                  "Enroll Now"
                )}
              </button>
              <button
                id="triggerSerious222"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#SecondSerious"
                style={{ display: 'none' }}
              ></button>
              <button
                id="triggerSerious1"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#Serious1"
                style={{ display: 'none' }}
              ></button>
            </div>
            {/*1st custom Modal */}
            <div
              className={`modal fade custom_modal `}
              id="Serious1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="SeriousLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content pb-60">
                  <button
                    type="button"
                    className="btn_close"
                    data-bs-dismiss="modal"
                  >
                    <img src={cross} alt="cross" className="cross_btn" />
                  </button>

                  <div className="modal-body">
                    <div className="modal_content">
                      <h1 className="f-26 text-center">
                        <span className="text_success">Note</span>
                      </h1>

                      {userData.paid_second === "" ? (
                        <>
                          {" "}
                          {
                            // userData.attypayment == "no" && 
                            (userData?.billingoptions === "client" || userData?.billingoptions === "CC") &&
                            (
                              <p className="f-16 text-center mt-12 fw-700">
                                The price for the course is
                                <span className="text_success">
                                  {" "}
                                  $
                                  {(secondPrice.label ?? getDisplayedCoursePrice(userData, "second"))}{" "}
                                </span>
                              </p>
                            )}
                          {
                            // userData.attypayment == null && 
                            userData?.billingoptions == "" &&
                            (
                              <p className="f-16 text-center mt-12 fw-700">
                                The price for the course is
                                <span className="text_success"> $ {(secondPrice.label ?? getDisplayedCoursePrice(userData, "second"))}</span>
                              </p>
                            )}
                        </>
                      ) : (
                        <></>
                      )}

                      {userId && userData.paid_second === "" &&
                        (userData?.billingoptions === "client" ||
                          userData?.billingoptions === "CC" ||
                          userData?.billingoptions === "") && (
                          <p className="f-16 text-center mt-2">
                            For free course, please{" "}
                            <span
                              className="text_success text-decoration-underline cursor-pointer"
                              data-bs-toggle="modal"
                              data-bs-target="#FreeCourseOneModal"
                            >
                              click here
                            </span>
                          </p>
                        )}

                      {
                        (userData?.billingoptions === "bill" || userData?.billingoptions === "DE") && (
                          // userData.attypayment == "yes" && (
                          <p className="f-16 text-center mt-12 fw-700">
                            Amount will be paid by your attorney
                          </p>
                        )}
                      {
                        // userData.paid_second === "" ? 


                        userData.paid_second == "" &&
                          (userData?.billingoptions === "client" || userData?.billingoptions === "CC"
                            || userData?.billingoptions === ""
                          )
                          ?

                          (
                            <>
                              {" "}
                              {secondPrice.data.totalAmount !== secondPrice.data.amount &&
                                // userData.attypayment == "no" && 
                                (
                                  <>
                                  <p className="f-16 text-center fw-700">
                                    Amount Payable
                                    <span className="text_success">
                                      {" "}
                                      ${Number(secondPrice.data.amount).toFixed(2)}{" "}
                                    </span>
                                  </p>
                                </>
                                )}
                            </>
                          ) : (
                            // userData.attypayment == "no" && 
                            userData.paid_second === "checked" &&
                            (userData?.billingoptions === "client" || userData?.billingoptions === "CC"
                              || userData?.billingoptions === ""
                            ) &&
                            (
                              <p className="f-16 text-center mt-12 fw-700">
                                The amount for the course is paid
                              </p>
                            )
                          )}

                      {secondPrice.error && <p role="alert" className="text-danger text-center">{secondPrice.error}</p>}


                      <div className="btn_wrap text-center mt-40">
                        <button
                          className="btn_brnd-outline mr-22 mb-2"
                          data-bs-dismiss="modal"
                          type="button"
                        >
                          Go Back
                        </button>

                        <button
                          className=" btn_brnd  mt-20"
                          data-bs-dismiss="modal"
                          disabled={postLoadingSecond || secondPrice.blocked}
                          onClick={() => {
                            if (userData.paid_second === "") {
                              if (
                                // userData.attypayment === "no" &&
                                (userData?.billingoptions === "client" || userData?.billingoptions === "CC" ||
                                  userData?.billingoptions === ""
                                ) &&
                                secondPrice.data.amount > 0
                              ) {
                                setShowModalSecond(true);
                              } else {
                                handleSubmitSecond({
                                  enrollInfo: courseSecondInfo,
                                });
                              }
                            } else {
                              handleSubmitSecond({
                                enrollInfo: courseSecondInfo,
                              });
                            }
                          }}
                          type={
                            (
                              // userData.attypayment === "yes" &&
                              (userData?.billingoptions === "bill" || userData?.billingoptions === "DE") &&
                              secondPrice.data.amount === 0) ||
                              userData.paid_second !== ""
                              ? "submit"
                              : "button"
                          }
                        >
                          {postLoadingSecond
                            ? "Processing..."
                            : "Confirm & Continue"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div
              className={`modal fade custom_modal `}
              id="SecondSerious"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="SeriousLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <Formik
                  initialValues={courseSecondInfo}
                  validationSchema={EnrollmentValidationSchema}
                  onSubmit={async (
                    values,
                    { resetForm, setSubmitting }
                  ) => {
                    setSubmitting(true);
                    await updateBankruptcy(
                      userId ? "admin" : "user",
                      userId ? userId : userData.user.data.id,
                      values
                    )
                      .then((res) => {

                         
                         setUserData((prev) => ({
                                      ...prev,
                                     bankruptcycasenum:values.bankruptcycasenum
                                    }));
                        // document.getElementById("SecondSerious").click();
                        // navigate(
                        //   inCompleteUserInfo ?
                        //         `/beforecontactwithcounselor?id=${user.user.data.id}&course=second`
                        //       :
                        //   userId
                        //     ? `/user-second-course?id=${userId}`
                        //     : verificationRequired === "true"
                        //     // ? "/security-law-questions?course=second"
                        //     ? "/2nd-course"
                        //     : "/2nd-course"
                        // );

                        resetForm();
                        setSubmitting(false);
                        document.getElementById("bankDismiss")?.click();
                        window.setTimeout(() => {
                          document
                            .getElementById(
                              userId
                                ? "triggerSerious1"
                                : "triggerEnrollmentCreditReportAuthorization"
                            )
                            ?.click();
                        }, 180);

                      })
                      .catch((err) => {
                        toast.error(err.response.data.error);
                        setSubmitting(false);
                      });
                  }}
                  enableReinitialize={true}
                >
                  {({ values, setValues, setTouched, isSubmitting, resetForm }) => (
                    <>
                      <Form>
                        <div className="modal-content pb-60">
                          <button
                            type="button"
                            className="btn_close"
                            data-bs-dismiss="modal"
                            id="bankDismiss"
                            onClick={() => {
                              resetForm();
                              setTouched({
                                bankruptcytype: false,
                                bankruptcycasenum: false,
                              });
                              setCourseSecondInfo({
                                bankruptcytype: "",
                                bankruptcycasenum: "",
                              });
                            }}
                          >
                            <img
                              src={cross}
                              alt="cross"
                              className="cross_btn"
                            />
                          </button>
                          <div className="modal-body">
                            <div className="modal_content">
                              <div className="row mt-40">
                                <div
                                  className="col-md-12 CreditCounseling_inner"
                                  style={{ paddingLeft: "12px" }}
                                  id="Bankruptcy"
                                >
                                  <div className="question">
                                    <div className="question_text">
                                      <h5 className="f-16 ">
                                        Bankruptcy Type
                                      </h5>
                                    </div>
                                  </div>
                                  <div
                                    className="radio_wrap_question"
                                    id="chapter"
                                  >
                                    <div className="iagree_radio mb-20">
                                      <Field
                                        type="radio"
                                        name="bankruptcytype"
                                        value="7"
                                        id="goals-yes"
                                        className=" "
                                      />
                                      <label htmlFor="goals-yes">
                                        Chapter 7
                                      </label>
                                    </div>
                                    <div className="iagree_radio">
                                      <Field
                                        type="radio"
                                        name="bankruptcytype"
                                        value="13"
                                        id="goals-no"
                                        className=" "
                                      />
                                      <label htmlFor="goals-no">
                                        Chapter 13{" "}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ marginTop: "-50px" }}>
                                  <ErrorMessage
                                    name="bankruptcytype"
                                    component="div"
                                    className="error text-danger"
                                  />
                                </div>
                                <div className="col-md-12 row">
                                  <div className="col-md-6">
                                    <div className="input_wrap">
                                      <label className="label-title">
                                        Bankruptcy Case Number
                                      </label>
                                      <Field
                                        type="text"
                                        placeholder="12-34567"
                                        name="bankruptcycasenum"
                                        className="form-control"
                                        maxlength="8"
                                        onChange={(e) => {
                                          if (
                                            e.target.value[
                                            e.target.value.length - 1
                                            ] !== " "
                                          ) {
                                            if (
                                              e.target.value.length === 2
                                            ) {
                                              setValues({
                                                ...values,
                                                bankruptcycasenum:
                                                  e.target.value + "-",
                                              });
                                            } else {
                                              setValues({
                                                ...values,
                                                bankruptcycasenum:
                                                  e.target.value,
                                              });
                                            }
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "Backspace" &&
                                            values.bankruptcycasenum
                                              .length === 3
                                          ) {
                                            setValues({
                                              ...values,
                                              bankruptcycasenum:
                                                e.target.value.slice(0, -1),
                                            });
                                          }
                                        }}
                                      />
                                      <ErrorMessage
                                        name="bankruptcycasenum"
                                        component="div"
                                        className="error text-danger"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="btn_wrap text-center">
                                <button
                                  className="btn_brnd-outline mr-22 mb-2"
                                  data-bs-dismiss="modal"
                                  // data-bs-toggle="modal"
                                  // data-bs-target="#Serious1"
                                  type="button"
                                  onClick={() => {
                                    resetForm()
                                    setTouched({
                                      bankruptcytype: false,
                                      bankruptcycasenum: false,
                                    });
                                    setCourseSecondInfo({
                                      bankruptcytype: "",
                                      bankruptcycasenum: "",
                                    });

                                  }}
                                >
                                  Go Back
                                </button>

                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className=" btn_brnd  mt-20"
                                >
                                  {isSubmitting ? (
                                    <ThreeDots
                                      height="20"
                                      width="100"
                                      radius="9"
                                      color="#4fa94d"
                                      ariaLabel="three-dots-loading"
                                      wrapperStyle={{
                                        display: "block",
                                      }}
                                      wrapperClassName="spinner"
                                      visible={true}
                                    />
                                  ) : (
                                    "Confirm & Continue"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  )}
                </Formik>
                <button
                  id="triggerSerious222"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#Serious222"
                  style={{ display: 'none' }}
                ></button>
                <button
                  id="triggerSerious1"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#Serious1"
                  style={{ display: 'none' }}
                ></button>
              </div>
            </div>
          </div>
        </div>
      )}
                <div
                  className="modal fade"
                  id="FreeCourseOneModal"
                  tabIndex="-1"
                  aria-labelledby="FreeCourseModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "100vh",
                    }}
                  >
                    <div
                      className="modal-content pb-60"
                      style={{
                        position: "relative",
                        padding: "40px 20px 30px",
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                      }}
                    >
                      {/* Cancel (X) Button */}
                      <button
                        type="button"
                        className="btn_close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "transparent",
                          border: "none",
                          fontSize: "24px",
                          fontWeight: "bold",
                          lineHeight: "1",
                          color: "#000",
                        }}
                      >
                        <img src={cross} alt="cross" className="cross_btn" />
                      </button>

                      <div className="modal-body">
                        <div className="modal_content">
                          <h4 className="f-20 text-center mb-3">Enter Free Course Code</h4>
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter your free code"
                              value={freeCode}
                              onChange={(e) => {
                                setFreeCode(e.target.value);
                                setFreeCodeError(""); // clear error while typing
                              }}
                            />
                            {freeCodeError && (
                              <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                                {freeCodeError}
                              </div>
                            )}
                          </div>

                          <div className="btn_wrap text-center mt-40">
                            <button
                              className="btn_brnd me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#Serious1"
                              data-bs-dismiss="modal"
                              type="button"
                            >
                              Go Back
                            </button>

                            <button
                              type="button"
                              onClick={()=>handleFreeCodeSubmit("FreeCourseOneModal")}
                              disabled={freeCodeLoading}
                              className="btn_brnd mt-20"
                            >
                              {freeCodeLoading ? (
                                <ThreeDots
                                  height="20"
                                  width="100"
                                  radius="9"
                                  color="#4fa94d"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{ display: "block" }}
                                  wrapperClassName="spinner"
                                  visible={true}
                                />
                              ) : (
                                "Confirm"
                              )}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
      <Footer />
    </div>
  );
};

export default EnrollmentIn2ndCourse;
